import React from 'react';
import Products from '../components/Products';

const QuiltsPage = () => {
  return <Products />;
};

export default QuiltsPage;